import { render, staticRenderFns } from "./listaEstadoPromocion.vue?vue&type=template&id=84f62c0c&scoped=true"
import script from "./listaEstadoPromocion.vue?vue&type=script&lang=js"
export * from "./listaEstadoPromocion.vue?vue&type=script&lang=js"
import style0 from "./listaEstadoPromocion.vue?vue&type=style&index=0&id=84f62c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f62c0c",
  null
  
)

export default component.exports